import { AppConfig } from '@dh-io-emh/config-types';
import AbstractRouter from './abstract-router';
import SeamlessRouterImpl from './seamless-router-impl';
import { AbstractRouterOptions, SeamlessRouterOptions } from './types';

export type RouterService = ReturnType<typeof createRouter>;

export const createRouter = ({
  config,
  routerOptions,
}: {
  config: AppConfig;
  routerOptions: AbstractRouterOptions;
}): AbstractRouter => {
  return new SeamlessRouterImpl(routerOptions as SeamlessRouterOptions, config.aemApp?.namespace);
};
